module.exports = __webpack_public_path__ + "img/logo-2.0d839c72.png";